// Diagnostic identifiers only. Never retain/render raw errors, URLs, keys,
// credentials, browser messages or response bodies.
const stages = new Set([
  'preflight', 'key', 'storage', 'session', 'permission', 'lock', 'cleanup',
  'config-read', 'config-check', 'worker-state', 'registration', 'subscription-read',
  'key-check', 'pending-store', 'subscribe', 'subscription-json', 'server-register',
  'binding-check', 'cleanup-store', 'worker-bind', 'cleanup-finish',
]);
const reasons = new Set([
  'push_not_ready', 'push_configuration_invalid', 'push_session_changed',
  'push_permission_denied', 'push_lock_unavailable', 'push_cleanup_unavailable',
  'push_cleanup_pending', 'push_configuration_changed', 'push_worker_unavailable',
  'push_binding_conflict', 'push_key_conflict', 'push_binding_invalid',
  'push_disabled', 'push_request_invalid', 'push_subscription_invalid',
  'permission_denied', 'inbox_update_in_progress', 'binding_unavailable',
  'binding_forbidden', 'binding_invalid', 'binding_conflict',
  'AbortError', 'NotAllowedError', 'InvalidStateError', 'NotSupportedError',
  'SecurityError', 'QuotaExceededError', 'NetworkError', 'TimeoutError',
  'DataError', 'OperationError', 'TypeError',
]);
const statuses = new Set([400, 401, 403, 404, 409, 429, 500, 502, 503, 504]);
const diagnostics = new WeakMap();

export function enrollmentFailure(problem, stage) {
  const safeStage = stages.has(stage) ? stage : 'unknown';
  let reason = 'unknown', status = '';
  try {
    const code = problem?.code, name = problem?.name, httpStatus = problem?.status;
    if (reasons.has(code)) reason = code;
    else if (reasons.has(name)) reason = name;
    if (statuses.has(httpStatus)) status = `/HTTP-${httpStatus}`;
  } catch { /* Even a throwing property must not defeat safe error reporting. */ }
  const error = new Error('Phone registration failed');
  diagnostics.set(error, `ENR1/${safeStage}/${reason}${status}`);
  return error;
}

export function enrollmentErrorCode(problem) {
  return diagnostics.get(problem) || 'ENR1/unknown/unknown';
}
